<template>
  <div class="invite-setting">
    <div class="form-wrap">
      <el-form ref="inviteForm" :model="self_inviteForm" label-width="100px">
        <el-form-item label="邀请有效期">
          <el-radio v-model="self_inviteForm.radio" :label="1">永久</el-radio>
        </el-form-item>
        <el-form-item label="邀请设置">
            <div>
              <el-checkbox @change="handleChangeExamine" v-model="self_inviteForm.needAudit" >邀请的分销商申请合作，需要您再次审核确认</el-checkbox>
            </div>
            <div>
              <el-checkbox @change="handleChangeExamine" v-model="self_inviteForm.needStaff">邀请链接关联业务员（业务员即分享邀约链接、邀约海报的用户）</el-checkbox>
            </div>
            <div>
              <el-checkbox @change="handleChangeExamine" v-model="self_inviteForm.assignPrivilege" :true-label="1" :false-label="0">邀请的分销商仅分配权限给关联业务员</el-checkbox>
              <el-tooltip content="勾选配置，则通过邀请链接绑定的分销商，只有发送邀请链接的业务员和超级管理员的分销商权限里会默认勾选该分销商，其余子账号不勾选；该权限低于【全部分销商】、【新增分销商】的权限；" placement="top" effect="dark">
                <i class="ml-5 el-icon-bangzhuzhongxin"></i>
              </el-tooltip>
            </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="tips">
      *设置后自动保存生效
    </div>
  </div>
</template>

<script>
import { isToExamine } from "@api/distributor";

export default {
  props:{
    inviteForm: {
      type: Object,
      default: ()=> {
        return {}
      }
    }
  },
  data() {
    return {
      self_inviteForm: {
        radio: 1,
        needAudit: true,
        needStaff: true,
        assignPrivilege: 0,
      }
    }
  },
  watch: {
    inviteForm: {
      handler(val){
        this.self_inviteForm = {...val, radio: 1}
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
     // 合作商需要审核
    async handleChangeExamine() {
      const res = await isToExamine({
        needAudit: this.self_inviteForm.needAudit ? 1 : 0,
        needStaff: this.self_inviteForm.needStaff ? 1: 0,
        assignPrivilege: this.self_inviteForm.assignPrivilege,
      });
     if(res.result == 1) {
       this.$message.success('设置成功')
     }
    },
  }
}
</script>

<style lang="scss" scoped>
  .form-wrap{
    background: #F5F6F7;
    padding: 20px 16px 16px 0px;
    margin-bottom:12px;
  }
  .tips{
    color: #9699A0;
    font-size: 12px;
  }
</style>
